import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp, FaInstagram, FaTiktok } from "react-icons/fa";
import logoImage from "../assets/United-logo-.2.png";
import { useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300); // Give the page time to render
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-black text-white mt-20">
      <div className="max-w-7xl mx-auto px-6 py-16 text-center space-y-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl font-bold "
        >
          United Event. We’re here
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-gray-300 max-w-2xl mx-auto text-sm leading-relaxed "
        >
          Your vision, our mission — we’re here to serve you better.
        </motion.p>

        <div className="flex justify-center space-x-4">
          <motion.button
            whileHover={{ scale: 1.05 }}
            onClick={() => scrollToSection("services")}
            className="bg-white text-black font-medium px-6 py-2 rounded-lg text-sm shadow hover:bg-gray-100 transition"
          >
            👀 Services
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.05 }}
            onClick={() => navigate("/contact")}
            className="bg-white text-black font-medium px-6 py-2 rounded-lg text-sm shadow hover:bg-gray-100 transition"
          >
            👋 Contact
          </motion.button>
        </div>

        <div className="border-t border-gray-800 pt-10 mt-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center justify-center">
            <img src={logoImage} alt="Logo" className="h-10 object-contain" />
          </div>

          <p className="text-xs text-gray-400">
            &copy; 2025 <strong>United Event</strong>. All rights reserved.
          </p>

          <div className="flex space-x-6 text-lg">
            {/* WhatsApp */}
            <a
              href="https://wa.me/96895566512"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition"
            >
              <FaWhatsapp />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/united.events.om?igsh=MW9xdGg3cXRpZ21waw=="
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition"
            >
              <FaInstagram />
            </a>

            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@united.events?_t=ZS-8wGlvHfSHxg&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition"
            >
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
